import React from "react";
import InputAdornment from "@mui/material/InputAdornment";
import MUIInputLabel from "@mui/material/InputLabel";
import { extractFormFieldError, getClassName } from "@sscs/utils";
import { Controller, useFormContext, } from "react-hook-form";
import CommonTextField from "../../TextField/TextField";
import { useControlSize } from "../formDense";
import formLayout from "../formLayout.module.scss";
import { useRegisterRequiredField } from "../requiredFields";
import styles from "./textField.module.scss";
function TextField({ type = "text", size, variant = "outlined", isRequired = false, isReadOnly = false, isDisabled = false, isFullWidth = true, ...props }) {
    const { control } = useFormContext();
    const resolvedSize = useControlSize(size);
    useRegisterRequiredField(isRequired);
    const { errorMessage: errorMessageString, hasError } = extractFormFieldError(props.name, props === null || props === void 0 ? void 0 : props.errors);
    const errorMessage = props.renderError
        ? props.renderError(errorMessageString)
        : errorMessageString;
    const cls = getClassName(styles.root, formLayout.field, props.className);
    return (React.createElement(Controller, { name: props.name, control: control, render: ({ field }) => { var _a; return (React.createElement("div", { className: cls },
            props.label && (React.createElement(MUIInputLabel, { htmlFor: props.id || props.name, error: hasError, required: isRequired, disabled: isDisabled }, props.label)),
            React.createElement(CommonTextField, { onChange: (event) => {
                    var _a;
                    field.onChange(event);
                    (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, event);
                }, onBlur: () => {
                    var _a;
                    field.onBlur();
                    (_a = props.onBlur) === null || _a === void 0 ? void 0 : _a.call(props);
                }, value: (_a = field.value) !== null && _a !== void 0 ? _a : "", name: field.name, id: props.id || props.name, inputRef: field.ref, type: type, variant: variant, size: resolvedSize, placeholder: props.placeholder, autoComplete: props.autoComplete, required: isRequired, fullWidth: isFullWidth, disabled: isDisabled, error: hasError, helperText: errorMessage || props.helperText, slotProps: {
                    input: {
                        readOnly: isReadOnly,
                        startAdornment: props.unit ? (React.createElement(InputAdornment, { position: "start" }, props.unit)) : undefined,
                    },
                    htmlInput: props.inputProps,
                } }))); } }));
}
export default TextField;
//# sourceMappingURL=TextField.js.map